import { Alert, AlertProps, AlertTitle, Button, Stack } from '@mui/material'
import { Valve } from '../types'
import { useTranslation } from 'react-i18next'
import ValveDetachHeaterButton from './ValveDetachHeaterButton'

export interface ValveDetachHeaterAlertProps extends Omit<AlertProps, 'children'> {
  valve: Valve
  title?: string
  afterUpdate?: (valve: Valve) => void
  onCancel?: () => void
}

export default function ValveDetachHeaterAlert({
  valve,
  title,
  afterUpdate,
  onCancel,
  sx,
  ...props
}: ValveDetachHeaterAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  /**
   * Handle the "after update" event.
   */
  function handleAfterSubmit() {
    afterUpdate?.({ ...valve, heaterId: null, heater: null })
  }

  return (
    <>
      {valve.heaterId !== null && (
        <Alert
          severity="warning"
          sx={{
            '& .MuiAlert-message': {
              width: '100%'
            },
            ...sx
          }}
          {...props}
        >
          <AlertTitle sx={{ m: 0 }}>{title ?? t('ValveDetachHeaterAlert.title')}</AlertTitle>

          <Stack direction="row" alignItems="center" gap={2} sx={{ mt: 1 }}>
            <ValveDetachHeaterButton
              valve={valve}
              variant="outlined"
              color="inherit"
              size="small"
              afterSubmit={handleAfterSubmit}
            >
              {t('ValveDetachHeaterAlert.yes')}
            </ValveDetachHeaterButton>

            <Button variant="outlined" color="inherit" size="small" onClick={onCancel}>
              {t('ValveDetachHeaterAlert.no')}
            </Button>
          </Stack>
        </Alert>
      )}
    </>
  )
}
